import * as React from 'react';
import debounce from 'lodash/debounce';
import { mergeStyles } from '@cian/utils/lib/shared/style';
import { MenuItem } from './MenuItem';
import { SpecialPromoLink } from '../../special_promo_link';
import { ISpecialPromoLinkData } from '../../../app/models/promo';
import { IDropdownMenuContainerProps } from '../../containers/DropdownMenuContainer';
import { TDropdownType } from '../DropdownMenu/interfaces';
import { IOtherLinksSchema } from '../../repositories/header/entities/other_links/OtherLinksSchema';

export interface ITopMenuLinks {
  name: string;
  title: string;
  trackingLabel?: string;
  link?: string;
  section?: string;
  regionIds?: number[];
}

export interface ITopMenuProps {
  dropdownMenusData: { [key: string]: IDropdownMenuContainerProps };
  specialPromoLinkData: ISpecialPromoLinkData;
  menuLinks: ITopMenuLinks[];
  catalogDevelopersUrl: string;
  catalogRealtorsUrl: string;
  otherLinks?: IOtherLinksSchema | null;
  activeKey?: string;
  regionId?: number;
}

export type THoverKey = TDropdownType & '';

export interface ITopMenuState {
  hoverKey: THoverKey;
  isFirstRender: boolean;
  activeKey?: string;
}

export class TopMenu extends React.Component<ITopMenuProps, ITopMenuState> {
  public constructor(props: ITopMenuProps) {
    super(props);

    this.state = {
      hoverKey: '' as THoverKey,
      isFirstRender: true,
      activeKey: props.activeKey,
    };
  }

  private menuListRef = React.createRef<HTMLUListElement>();

  public componentDidMount(): void {
    this.setState({
      isFirstRender: false,
    });
  }

  private handleShow = (key: string) => {
    this.setState({
      hoverKey: key as THoverKey,
    });
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private handleHide = (key: string) => {
    this.setState({
      hoverKey: '' as THoverKey,
    });
  };

  private handleMouseOver = (key: string) => {
    this.debouncedFnsCancel();

    const { hoverKey } = this.state;

    if (hoverKey !== key) {
      this.debouncedHandleShow(key);
    }
  };

  private handleMouseOut = (key: string) => {
    this.debouncedFnsCancel();

    const { hoverKey } = this.state;

    if (hoverKey !== '') {
      this.debouncedHandleHide(key);
    }
  };

  private debouncedFnsCancel() {
    this.debouncedHandleShow.cancel();
    this.debouncedHandleHide.cancel();
  }

  private debouncedHandleShow = debounce(this.handleShow, 200);

  private debouncedHandleHide = debounce(this.handleHide, 200);

  public render() {
    const {
      dropdownMenusData,
      specialPromoLinkData,
      menuLinks,
      catalogDevelopersUrl,
      catalogRealtorsUrl,
      otherLinks,
      regionId,
    } = this.props;
    const { hoverKey, activeKey, isFirstRender } = this.state;

    return (
      <div>
        <ul className="c-header-bottom-menu" data-ref="bottom_menu" ref={this.menuListRef}>
          {menuLinks.map((menu, key) => {
            const { name, title, trackingLabel, link, section } = menu;
            const isActive = !!section && activeKey === section;

            return (
              <MenuItem
                key={`menu-${key}`}
                onMouseOver={this.handleMouseOver}
                onMouseOut={this.handleMouseOut}
                isOpen={hoverKey === name}
                dropdownMenusData={dropdownMenusData[name]}
                link={link}
                catalogDevelopersUrl={catalogDevelopersUrl}
                catalogRealtorsUrl={catalogRealtorsUrl}
                otherLinks={otherLinks}
                handleCloseClick={this.handleHide}
                isActive={isActive}
                title={title}
                trackingLabel={trackingLabel}
                name={name}
                regionId={regionId}
                section={section}
              />
            );
          })}

          <li className="c-header-bottom-menu-item" id="header-sp-link-container">
            <SpecialPromoLink {...specialPromoLinkData} />
          </li>
        </ul>
        <div
          {...mergeStyles(
            'overlay',
            hoverKey === '' && ' hidden',
            !isFirstRender && { height: document.body.offsetHeight },
          )}
        />
      </div>
    );
  }
}
